exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ins-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    background-color: #F2F2F1;\r\n}\r\n\r\n.card-container {\r\n    margin: auto;\r\n    width: 90%;\r\n    min-width: 200px;\r\n    margin-top: 20px;\r\n    border: solid 2px #23527C;\r\n}\r\n\r\n.pad {\r\n    margin-bottom: 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/institutions/institution-update/institution-update.component.css
// module id = ../../../../../src/app/institutions/institution-update/institution-update.component.css
// module chunks = main